const Container = ({ children, styleClass }) => {
  return (
    <div className={"row " + styleClass}>
      <div className="col-12 col-md-9 mx-auto">{children}</div>
    </div>
  );
};

export default Container;
